<span *ngIf="event.actions" class="cal-event-actions">
    <a
        class="cal-event-action"
        href="javascript:;"
        *ngFor="let action of event.actions"
        (calClick)="action.onClick({event: event})"
        [ngClass]="action.cssClass"
        [innerHtml]="action.label">
    </a>
</span>